'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import NoSSR from '@haaretz/s-no-ssr';
import useLogPurchaseVisit from '../../hooks/useLogVisit';
import useUserAssistance from '../../hooks/useUserAssistance';
function PpSideEffects() {
    useLogPurchaseVisit();
    return null;
}
export default function PpSideEffectsWrapper() {
    useUserAssistance();
    return /*#__PURE__*/ _jsx(NoSSR, {
        children: /*#__PURE__*/ _jsx(PpSideEffects, {})
    });
}

//# sourceMappingURL=PpSideEffects.js.map